import React, { useEffect, useState } from 'react';
import { Slider } from '@mui/material';
import { makeStyles } from '~/UIKit/Style';
import { ColorButton } from '~/UIKit/ColorButton';
import { WHITE } from '~/Constants/Colors.constants';
import { BOX_SHADOW_ACTIVE } from '~/Constants/CSS.constants';
import { calculateSelectedColor, hexToHue, COLORS } from './colorPickerHelper';

const useStyles = makeStyles((theme) => ({
  colorSliderWrapper: {
    display: 'flex',
    marginBottom: theme.spacing(2),
    alignItems: 'center',
  },
  colorButtonWrapper: {
    margin: 'auto',
    marginRight: 0,
  },
  slider: {
    flexGrow: 1,
  },
  ColorSliderRoot: {
    padding: 0,
    marginRight: theme.spacing(2),
    height: '13px',
    borderRadius: '8px',
    // eslint-disable-next-line max-len
    background: `linear-gradient(270deg, ${COLORS[0]} 0%, ${COLORS[1]} 15.44%, ${COLORS[2]} 33.32%, ${COLORS[3]} 50%, ${COLORS[4]} 66.64%, ${COLORS[5]} 83.3%, ${COLORS[6]} 100%)`,
  },
  ColorSliderRail: {
    display: 'none',
  },
  ColorSliderTrack: {
    display: 'none',
  },
  ColorSliderThumb: {
    marginTop: '-3px',
    height: 26,
    width: 26,
    boxShadow: BOX_SHADOW_ACTIVE,
    border: `6px solid ${WHITE}`,
  },
}));

interface ColorSliderProps {
  color: string;
  onChange: (color: string) => void;
}

export const ColorSlider = ({ color, onChange }: ColorSliderProps) => {
  const [sliderValue, setSliderValue] = useState(0);
  const { classes } = useStyles();
  const colorSelectedFromSlider = calculateSelectedColor(sliderValue);

  const handleSliderUpdate = (_e: Event, value: number | number[]) => {
    setSliderValue(value as number);
  };

  useEffect(() => {
    if (colorSelectedFromSlider !== color) {
      const newSliderPosition = hexToHue(color);
      setSliderValue(newSliderPosition);
    }
  }, [color]);

  return (
    <div className={classes.colorSliderWrapper}>
      <Slider
        style={{
          color,
        }}
        value={sliderValue}
        onChange={handleSliderUpdate}
        className={classes.slider}
        onChangeCommitted={() => onChange(colorSelectedFromSlider)}
        classes={{
          root: classes.ColorSliderRoot,
          rail: classes.ColorSliderRail,
          track: classes.ColorSliderTrack,
          thumb: classes.ColorSliderThumb,
        }}
        max={360}
      />
      <div className={classes.colorButtonWrapper}>
        <ColorButton color={color} isButtonSelected={false} variation="secondary" />
      </div>
    </div>
  );
};
